import { defineStore } from 'pinia'
import type { CanvasRenderMode } from '@/util/canvas-render-mode'

export type AppState = {
  isInPreviewMode: boolean
  isInPrintMode: boolean
}

export const useAppStore = defineStore('app', {
  state: (): AppState => ({
    isInPreviewMode: false,
    isInPrintMode: false
  }),
  getters: {
    /** See canvas-render-mode.ts; print mode is the PDF export. */
    canvasRenderMode: (state): CanvasRenderMode => (state.isInPrintMode ? 'export' : 'interactive')
  },
  actions: {
    async setPreviewMode(value: boolean) {
      this.isInPreviewMode = value
    },
    async setPrintMode(value: boolean) {
      this.isInPrintMode = value
    }
  }
})

export type AppStore = ReturnType<typeof useAppStore>
